import { Route } from '@angular/router';
import { AppLayoutComponent } from './shell/app.layout.component';
import { AuthChallengeGuard, AuthClaimGuard } from '@lib/auth/data-access';
import { CLAIMS } from '@lib/auth/models';

export const appRoutes: Route[] = [
    //LEAVE THESE ROUTES IN THIS ORDER TO ENSURE PROPER ROUTING
    //Non-authenticated routes
    {
        path: '',
        redirectTo: 'challenge',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadComponent: () => import('@lib/login/feature-login').then(m => m.LoginComponent)
    },
    {
        path: 'challenge', //I added this component to avoid the flashing of the login page if the user is already logged in but landed at the root url or login url.
        loadComponent: () => import('@lib/auth/feature-auth-challenge').then(m => m.AuthChallengeComponent)
    },
    {
        path: 'system-maintenance',
        loadComponent: () => import('@lib/tenant/feature-system-maintenance').then(m => m.SystemMaintenanceComponent)
    },

    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [AuthChallengeGuard],
        children: [
            {
                path: 'error-unauthorized',
                loadComponent: () => import('@lib/shared/ui').then(m => m.ErrorUnauthorizedComponent)
            },
            {
                path: 'error-not-found',
                loadComponent: () => import('@lib/shared/ui').then(m => m.ErrorNotFoundComponent)
            },
            {
                path: 'profile',
                loadChildren: () => import('@lib/profile/feature-landing').then(m => m.PROFILE_ROUTES),
                canActivate: [AuthClaimGuard],
                data: {
                    claims: [CLAIMS.ADMINISTRATOR, CLAIMS.CODY_SYSTEMS_EMPLOYEE],
                    allClaimsRequired: false
                }
            },
            {
                path: 'administration-center',
                children: [
                    {
                        path: '',
                        redirectTo: 'users',
                        pathMatch: 'full'
                    },
                    {
                        path: 'roles',
                        loadChildren: () => import('@lib/administration-center/feature-roles').then(m => m.ROLES_ROUTES)
                    },
                    {
                        path: 'users',
                        loadChildren: () => import('@lib/administration-center/feature-users').then(m => m.USERS_ROUTES)
                    },
                    {
                        path: 'audit',
                        loadChildren: () => import('@lib/administration-center/feature-audit').then(m => m.AUDIT_ROUTES)
                    }
                ],
                canActivate: [AuthClaimGuard],
                data: {
                    claims: [CLAIMS.ADMINISTRATOR, CLAIMS.CODY_SYSTEMS_EMPLOYEE],
                    allClaimsRequired: false
                }
                
            },
            {
                path: 'super-admin',
                loadChildren: () => import('@lib/super-admin/feature-landing').then(m => m.SUPER_ADMIN_ROUTES),
                canActivate: [AuthClaimGuard],
                data: {
                    claims: [CLAIMS.CODY_SYSTEMS_EMPLOYEE],
                    allClaimsRequired: true
                }
            },

            //MUST BE LAST IN THE ROUTES LIST
            //Catch-all for undefined routes
            {
                path: '**',
                redirectTo: 'error-not-found'
            }
        ]
    }
];
